// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"DocumentBreadcrumb_breadcrumb__VeFIJ","label":"DocumentBreadcrumb_label__rEpN5"};